import { CreditSafeCompany } from './credit-safe.company.entity';
import { Partial } from '@40seas/entities/common';

export class UpdateCreditSafeCompanyDto extends Partial(CreditSafeCompany) {}
